export const FooterLinks: { title: string; titleAr: string; link: string; linkAr: string }[] = [
  {
    title: 'Home',
    titleAr: 'الصفحة الرئيسية',
    linkAr: 'https://tawal.com.sa/ar/index',
    link: 'https://tawal.com.sa/en/index',
  },
  {
    title: 'About Us',
    titleAr: 'نبذة عنا',
    linkAr: 'https://tawal.com.sa/ar/about-us',
    link: 'https://tawal.com.sa/en/about-us',
  },
  {
    title: 'Our Markets',
    titleAr: 'أسواقنا',
    linkAr: 'https://tawal.com.sa/ar/market',
    link: 'https://tawal.com.sa/en/market',
  },
  {
    title: 'Solutions',
    titleAr: 'الحلول',
    linkAr: 'https://tawal.com.sa/ar/solutions',
    link: 'https://tawal.com.sa/en/solutions',
  },
  {
    title: 'Sustainability',
    titleAr: 'استدامتنا',
    linkAr: 'https://tawal.com.sa/ar/sustainability',
    link: 'https://tawal.com.sa/en/sustainability',
  },
  {
    title: 'Join Our Team',
    titleAr: 'انضم إلى فريقنا',
    linkAr: 'https://tawal.com.sa/ar/team',
    link: 'https://tawal.com.sa/en/team',
  },
  {
    title: 'Media',
    titleAr: 'الأخبار',
    linkAr: 'https://tawal.com.sa/ar/media',
    link: 'https://tawal.com.sa/en/media',
  },
  {
    title: 'FAQs',
    titleAr: 'الأسئلة الشائعة',
    linkAr: 'https://tawal.com.sa/ar/faqs',
    link: 'https://tawal.com.sa/en/faqs',
  },
  {
    title: 'Whistleblower',
    titleAr: 'الممارسات المخالفة',
    linkAr: 'https://tawal.com.sa/ar/whistleblower',
    link: 'https://tawal.com.sa/en/whistleblower',
  },
  {
    title: 'Contact Us',
    titleAr: 'اتصل بنا',
    linkAr: 'https://tawal.com.sa/ar/contact-us',
    link: 'https://tawal.com.sa/en/contact-us',
  },
  {
    title: 'Brand Guidelines',
    titleAr: 'القواعد الإرشادية للهوية',
    linkAr: 'https://tawal.com.sa/ar/brand',
    link: 'https://tawal.com.sa/en/brand',
  },
  {
    title: 'Knowledge Center',
    titleAr: 'مركز المعرفة',
    linkAr: '/knowledge-center/ar',
    link: '/knowledge-center/en',
  },
  {
    title: 'Privacy Notice',
    titleAr: 'إشعار الخصوصية',
    linkAr: 'https://tawal.com.sa/ar/privacy-notice',
    link: 'https://tawal.com.sa/en/privacy-notice',
  },
];
